/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Step_Cheapest_NoteInputs */

const en_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every page starts here`)
};

const zh_hans1_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个页面都从这里开始`)
};

const pt_br2_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda página começa aqui`)
};

const es_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada página empieza aquí`)
};

const fr_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque page commence ici`)
};

const de_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Seite startet hier`)
};

const ru_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С него начинается каждая страница`)
};

const it_scrape_router_step_cheapest_note = /** @type {(inputs: Scrape_Router_Step_Cheapest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni pagina parte da qui`)
};

/**
* | output |
* | --- |
* | "Every page starts here" |
*
* @param {Scrape_Router_Step_Cheapest_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_step_cheapest_note = /** @type {((inputs?: Scrape_Router_Step_Cheapest_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Step_Cheapest_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_step_cheapest_note(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_step_cheapest_note(inputs)
	if (locale === "es") return es_scrape_router_step_cheapest_note(inputs)
	if (locale === "fr") return fr_scrape_router_step_cheapest_note(inputs)
	if (locale === "de") return de_scrape_router_step_cheapest_note(inputs)
	if (locale === "ru") return ru_scrape_router_step_cheapest_note(inputs)
	if (locale === "it") return it_scrape_router_step_cheapest_note(inputs)
	return en_scrape_router_step_cheapest_note(inputs)
});